import Controller from '@ember/controller';
import { action, get, set, setProperties } from '@ember/object';
import { service } from '@ember/service';
import RSVP from 'rsvp';

export default Controller.extend({
  router: service(),
  store: service(),
  storeCache: service(),

  saving: false,
  errorMessage: null,

  reset() {
    setProperties(this, {
      saving: false,
      errorMessage: null,
    });
  },

  save: action(function (selectedItems) {
    if (get(selectedItems, 'length') === 0) {
      set(
        this,
        'errorMessage',
        'You must select at least one fund for the user',
      );
      return;
    } else {
      set(this, 'errorMessage', null);
    }

    set(this, 'saving', true);
    let store = this.store;
    let user = get(this, 'model.user');
    let previousUserFunds = get(this, 'model.userFunds');
    let savePromises = [];

    // Save new funds
    selectedItems.forEach((item) => {
      if (get(item, 'userFund') == null) {
        let newUserFund = store.createRecord('admin/user-fund', {
          userId: get(user, 'id'),
          fundId: get(item, 'fund.id'),
        });
        savePromises.push(newUserFund.save());
      }
    });
    // Remove previous funds that are no longer selected
    previousUserFunds.forEach((prevUserFund) => {
      let prevUserFundId = get(prevUserFund, 'id');
      let selectedItem = selectedItems.find((item) => {
        return get(item, 'userFund.id') === prevUserFundId;
      });
      if (selectedItem == null) {
        savePromises.push(prevUserFund.destroyRecord());
      }
    });

    RSVP.allSettled(savePromises).then(() => {
      set(this, 'saving', false);
      this.storeCache.breakFindAllCache('admin/user-fund');

      // TODO: Eric - do we need to refresh the route?
      this.router.transitionTo('admin.users.show');
    });
  }),
});
